import ExcelJS from "exceljs";
import { htmlToText } from "html-to-text";
import ReactHtmlParser from "react-html-parser";


// Helper function for downloading Excel
// export const handleDownloadExcel = async (rfqData, userProfile, getInitialValues, setExcelLoading, setLoadingMessage, isAdvancedTransport) => {
//     try {
//         setExcelLoading(true);
//         setLoadingMessage("Preparing the Excel file for download...");

//         // Load the Excel template
//         const templatePath = "/assets/general/bulk_template_material_rates_.xlsx";
//         const response = await fetch(templatePath);
//         const buffer = await response.arrayBuffer();

//         // Load workbook from the buffer
//         const workbook = new ExcelJS.Workbook();
//         await workbook.xlsx.load(buffer);

//         // Access the specific sheet
//         const sheet = workbook.getWorksheet("bulk_material_rates");

//         // Use rfqData.materials and initial form values to prepare data
//         const materials = getInitialValues(rfqData, userProfile).materials || [];

//         // Populate the sheet starting from row 3
//         materials?.forEach((material, index) => {
//             const row = sheet.getRow(index + 3); // Start from row 3

//             // Populate the row with material data
//             row.getCell(1).value = index + 1; // Sr
//             row.getCell(2).value = material.id; // Neevay_ID
//             row.getCell(3).value = htmlToText(material.name); // Material_Name
//             row.getCell(4).value = htmlToText(material.specifications); // Specification
//             row.getCell(5).value = material.brand; // Approved_brand
//             row.getCell(6).value = material.quantity; // Qty
//             row.getCell(7).value = material.unit; // Unit

//             // Populate the editable fields based on material data
//             row.getCell(8).value = material.basePrice || null; // MRP
//             row.getCell(9).value = material.discount > 0 && `${material.discount}%` || null; // Discount
//             row.getCell(10).value = material.gst ? `${material.gst}%` : `18%`; // GST
//             row.getCell(11).value = htmlToText(material.remark) || null; // Vendor_Remarks

//             // Set formulas for calculated fields
//             row.getCell(12).value = { formula: `H${index + 3} - (H${index + 3} * I${index + 3})` } || null; // Corrected Net_Rate formula
//             row.getCell(13).value = { formula: `L${index + 3} * F${index + 3}` } || null; // Basic_Amount formula remains unchanged
//             row.getCell(14).value = { formula: `M${index + 3} * J${index + 3}` } || null; // Corrected GST_Amount formula
//             row.getCell(15).value = { formula: `M${index + 3} + N${index + 3}` } || null; // Total_Amount_with_GST formula remains unchanged
//         });

//         // Ensure the sheet protection and styles are preserved
//         sheet.protect("Neevay", {
//             selectLockedCells: true,
//             selectUnlockedCells: true,
//         });

//         // Generate and download the updated file
//         const blob = await workbook.xlsx.writeBuffer();
//         const url = URL.createObjectURL(new Blob([blob]));
//         const link = document.createElement("a");
//         link.href = url;
//         link.download = `RFQ-${rfqData?.rfqId}_material_upload.xlsx`;
//         link.click();
//         URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error processing Excel file:", error);
//     } finally {
//         setExcelLoading(false);
//         setLoadingMessage("");
//     }
// };


export const handleDownloadExcel = async (
    rfqData,
    userProfile,
    getInitialValues,
    setExcelLoading,
    setLoadingMessage,
    isAdvancedTransport
) => {
    try {
        setExcelLoading(true);
        setLoadingMessage("Preparing the Excel file for download...");

        // Load the appropriate template based on isAdvancedTransport
        const templatePath = isAdvancedTransport
            ? "/assets/general/bulk_template_material_rates_with_transport.xlsx"
            : "/assets/general/bulk_template_material_rates_.xlsx";
        const response = await fetch(templatePath);
        const buffer = await response.arrayBuffer();

        // Load workbook from the buffer
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        // Access the specific sheet
        const sheet = workbook.getWorksheet("bulk_material_rates");

        // Use rfqData.materials and initial form values to prepare data
        const materials = getInitialValues(rfqData, userProfile).materials || [];

        // Populate the sheet starting from row 3
        materials?.forEach((material, index) => {
            const row = sheet.getRow(index + 3); // Start from row 3
            let colIndex = 1;

            // Populate the row with material data
            row.getCell(colIndex++).value = index + 1; // Sr
            row.getCell(colIndex++).value = material.id; // Neevay_ID
            row.getCell(colIndex++).value = htmlToText(material.name); // Material_Name
            row.getCell(colIndex++).value = htmlToText(material.specifications); // Specification
            row.getCell(colIndex++).value = material.brand; // Approved_brand
            row.getCell(colIndex++).value = material.quantity; // Qty
            row.getCell(colIndex++).value = material.unit; // Unit

            // Populate the editable fields based on material data
            row.getCell(colIndex++).value = material.basePrice || null; // MRP
            row.getCell(colIndex++).value = material.discount > 0 ? `${material.discount}%` : null; // Discount

            if (isAdvancedTransport) {
                row.getCell(colIndex++).value = material.transportRate || null; // Transport Rate
            }

            row.getCell(colIndex++).value = material.gst ? `${material.gst}%` : `18%`; // GST
            row.getCell(colIndex++).value = htmlToText(material.remark) || null; // Vendor_Remarks

            // Set formulas for calculated fields
            if (isAdvancedTransport) {
                row.getCell(colIndex).value = { formula: `ROUNDDOWN(H${index + 3} - (H${index + 3} * I${index + 3} / 100), 0)` } || null; // Net_Rate formula
            } else {
                row.getCell(colIndex).value = { formula: `ROUNDDOWN(H${index + 3} * (1 - I${index + 3}), 0)` } || null; // Net_Rate formula
            }
            colIndex++;

            if (isAdvancedTransport) {
                row.getCell(colIndex).value = { formula: `J${index + 3} * F${index + 3}` } || null; // Transport Cost (Transport Rate * Qty)
                colIndex++;
            }

            // Correcting the formula for Basic_Amount
            if (isAdvancedTransport) {
                row.getCell(colIndex).value = { formula: `M${index + 3} * F${index + 3}` } || null; // Basic_Amount using Net_Rate (L)
            } else {
                row.getCell(colIndex).value = { formula: `L${index + 3} * F${index + 3}` } || null; // Basic_Amount using Net_Rate (K)
            }
            colIndex++;

            // GST_Amount formula
            if (isAdvancedTransport) {
                row.getCell(colIndex).value = { formula: `ROUNDDOWN(O${index + 3} * (SUBSTITUTE(K${index + 3}, "%", "") / 100) + N${index + 3} * 18 / 100, 0)` } || null;
                colIndex++;
            } else {
                row.getCell(colIndex).value = { formula: `M${index + 3} * J${index + 3}` } || null; // Corrected GST_Amount formula
                colIndex++;
            }

            if (isAdvancedTransport) {
                row.getCell(colIndex).value = { formula: `N${index + 3} + O${index + 3} + P${index + 3}` } || null; // Total_Amount_with_GST
            } else {
                row.getCell(colIndex).value = { formula: `M${index + 3} + N${index + 3}` } || null; // Total_Amount_with_GST
            }
        });

        // Ensure the sheet protection and styles are preserved
        sheet.protect("Neevay", {
            selectLockedCells: true,
            selectUnlockedCells: true,
        });

        // Generate and download the updated file
        const blob = await workbook.xlsx.writeBuffer();
        const url = URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.download = `${rfqData?.name?.substring(0, 25) || "Export"}_${rfqData?.rfqType || ""}_${rfqData?.rfqId || ""}_upload.xlsx`;
        link.click();
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error processing Excel file:", error);
    } finally {
        setExcelLoading(false);
        setLoadingMessage("");
    }
};


// Helper function for uploading Excel
// export const handleUploadExcel = async (event, setFieldValue, values, rfqData, totalCosts, setExcelLoading, setLoadingMessage, enqueueSnackbar, calculateTotalCost, setTotalCosts, calculateOverallTotal, calculateOverallTotalWithoutGST) => {
//     try {
//         setExcelLoading(true);
//         setLoadingMessage("Processing the uploaded Excel file...");
//         const file = event.target.files[0];
//         if (!file) return;

//         const workbook = new ExcelJS.Workbook();
//         await workbook.xlsx.load(await file.arrayBuffer());
//         const sheet = workbook.getWorksheet("bulk_material_rates");

//         const updatedMaterials = [...values.materials];
//         const updatedTotalCosts = [...totalCosts];
//         const errors = [];

//         sheet.eachRow((row, rowNumber) => {
//             if (rowNumber < 3) return; // Skip header rows

//             const materialIndex = rowNumber - 3;
//             const material = updatedMaterials[materialIndex];

//             if (material) {
//                 const uploadedNeevayId = row.getCell(2).value; // Neevay_ID from Excel

//                 // **New Logic**: Validate if Neevay_ID matches any material._id in rfqData.materials
//                 const isValidMaterial = rfqData?.materials.some((item) => item._id === uploadedNeevayId);
//                 if (!isValidMaterial) {
//                     errors.push(`Please upload correct sheet. Invalid material at row ${rowNumber}: Neevay_ID does not match.`);
//                     return; // Skip processing this row
//                 }

//                 const mrp = row.getCell(8).value; // MRP
//                 const discount = row.getCell(9).value; // Discount
//                 let gst = row.getCell(10).value; // GST
//                 const remarks = row.getCell(11).value; // Vendor_Remarks
//                 const totalExclGstValue = row.getCell(13).value; // Vendor_Remarks

//                 // Convert raw discount value to percentage if needed
//                 let discountValue = parseFloat(discount);
//                 if (discountValue && discountValue <= 1) {
//                     discountValue = discountValue * 100; // Convert to percentage
//                 }

//                 // Handle GST percentage conversion
//                 if (gst && gst < 1) {
//                     gst = gst * 100; // Convert to whole number percentage if needed
//                 }

//                 // Validation: MRP must not be empty
//                 if (mrp === undefined || mrp === null || isNaN(mrp)) {
//                     errors.push(`MRP is empty or invalid in row ${rowNumber}`);
//                     return;
//                 }

//                 // Update material fields
//                 material.basePrice = parseFloat(mrp) || 0;
//                 material.discount = discountValue || 0;
//                 material.gst = parseFloat(gst) || 0;
//                 material.remark = remarks || "";
//                 material.totalExclGst = ((material.basePrice - (material.basePrice * material.discount) / 100) * material.quantity);

//                 // Recalculate totalCost
//                 const totalCost = calculateTotalCost(
//                     material.basePrice,
//                     material.quantity,
//                     material.discount,
//                     material.gst
//                 );
//                 material.totalCost = totalCost;

//                 // Update totalCosts array
//                 updatedTotalCosts[materialIndex] = totalCost;
//             }
//         });

//         if (errors.length > 0) {
//             enqueueSnackbar(errors.join(", "), { variant: "error" });
//             return;
//         }

//         // Update form values and totalCosts state
//         setFieldValue("materials", updatedMaterials);
//         setTotalCosts(updatedTotalCosts);

//         // Calculate the overall total after updating total costs
//         calculateOverallTotal(updatedTotalCosts, values?.miscellaneousCosts);
//         calculateOverallTotalWithoutGST(updatedMaterials, values?.miscellaneousCosts)

//         enqueueSnackbar("Excel uploaded and data updated successfully!", { variant: "success" });
//     } catch (error) {
//         console.error("Error processing Excel file:", error);
//         enqueueSnackbar("Failed to upload Excel file.", { variant: "error" });
//     } finally {
//         setExcelLoading(false);
//         setLoadingMessage("");
//     }
// };



export const handleUploadExcel = async (
    event,
    setFieldValue,
    values,
    rfqData,
    totalCosts,
    setExcelLoading,
    setLoadingMessage,
    enqueueSnackbar,
    calculateTotalCost,
    setTotalCosts,
    calculateOverallTotal,
    calculateOverallTotalWithoutGST,
    isAdvancedTransport
) => {
    try {
        setExcelLoading(true);
        setLoadingMessage("Processing the uploaded Excel file...");
        const file = event.target.files[0];
        if (!file) return;

        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(await file.arrayBuffer());
        const sheet = workbook.getWorksheet("bulk_material_rates");

        const updatedMaterials = [...values.materials];
        const updatedTotalCosts = [...totalCosts];
        const errors = [];

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber < 3) return; // Skip header rows

            const materialIndex = rowNumber - 3;
            const material = updatedMaterials[materialIndex];

            if (material) {
                const uploadedNeevayId = row.getCell(2).value; // Neevay_ID from Excel

                // **Validate if Neevay_ID matches any material._id in rfqData.materials**
                const isValidMaterial = rfqData?.materials.some((item) => item._id === uploadedNeevayId);
                if (!isValidMaterial) {
                    errors.push(`Invalid material at row ${rowNumber}: Neevay_ID does not match.`);
                    return;
                }

                let colIndex = 8; // MRP column starts at index 8 (H in Excel)

                const basePrice = parseFloat(row.getCell(colIndex++).value) || 0; // MRP
                let discount = row.getCell(colIndex++).value; // Discount

                let transportRate = 0;
                if (isAdvancedTransport) {
                    transportRate = parseFloat(row.getCell(colIndex++).value) || 0; // Transport Rate
                }

                let gst = row.getCell(colIndex++).value; // GST
                const remark = row.getCell(colIndex++).value || ""; // Vendor_Remarks

                let netRate = row.getCell(colIndex++).value; // Net Rate
                let transportCost = 0;
                if (isAdvancedTransport) {
                    transportCost = parseFloat(row.getCell(colIndex++).value) || 0; // Transport Cost
                }

                let basicAmount = row.getCell(colIndex++).value; // Basic Amount
                let gstAmount = row.getCell(colIndex++).value; // GST Amount
                let totalAmountWithGst = row.getCell(colIndex++).value; // Total Amount

                // Convert discount if in percentage format
                discount = discount && typeof discount === "string" && discount.includes("%")
                    ? parseFloat(discount.replace("%", ""))
                    : parseFloat(discount) || 0;

                if (discount > 1) {
                    discount = discount; // Already in percent
                } else if (discount > 0 && discount <= 1) {
                    discount = discount * 100; 
                }

                // Convert GST if in percentage format
                gst = gst && typeof gst === "string" && gst.includes("%")
                    ? parseFloat(gst.replace("%", ""))
                    : parseFloat(gst) || 18; // Default to 18%

                // **Calculate Net Price**
                const netPrice = basePrice - (basePrice * discount) / 100;

                // **Calculate Transport Cost**
                transportCost = transportRate * material.quantity;

                // **Calculate Total Excluding GST**
                const totalExclGst = netPrice * material.quantity + transportCost;

                // **Calculate Final Total Cost**
                const totalCost = calculateTotalCost(basePrice, material.quantity, discount, gst, transportCost);

                // **Update Material Fields**
                material.basePrice = basePrice;
                material.discount = discount;
                material.gst = gst;
                material.remark = remark;
                material.netPrice = netPrice;
                material.transportRate = transportRate;
                material.transportCost = transportCost;
                material.totalExclGst = totalExclGst;
                material.totalCost = totalCost;
                material.basicAmount = basicAmount;
                material.gstAmount = gstAmount;
                material.totalAmountWithGst = totalAmountWithGst;

                // **Update Total Costs Array**
                updatedTotalCosts[materialIndex] = totalCost;
            }
        });

        if (errors.length > 0) {
            enqueueSnackbar(errors.join(", "), { variant: "error" });
            return;
        }

        // **Update Form Values and Total Costs**
        setFieldValue("materials", updatedMaterials);
        setTotalCosts(updatedTotalCosts);

        // **Recalculate Miscellaneous Costs for Transport**
        const totalTransportMRP = updatedMaterials.reduce((sum, item) => sum + (item.transportCost || 0), 0);
        const transportGst = parseFloat(values.miscellaneousCosts.transport.gst) || 18;
        const transportTotalCost = totalTransportMRP + (totalTransportMRP * transportGst) / 100;

        setFieldValue("miscellaneousCosts.transport.mrp", totalTransportMRP);
        setFieldValue("miscellaneousCosts.transport.totalCost", transportTotalCost);

        // **Calculate Overall Totals**
        calculateOverallTotal(updatedTotalCosts, values.miscellaneousCosts);
        calculateOverallTotalWithoutGST(updatedMaterials, values.miscellaneousCosts);

        enqueueSnackbar("Excel uploaded and data updated successfully!", { variant: "success" });
    } catch (error) {
        console.error("Error processing Excel file:", error);
        enqueueSnackbar("Failed to upload Excel file.", { variant: "error" });
    } finally {
        setExcelLoading(false);
        setLoadingMessage("");
    }
};
